import { observer } from 'mobx-react-lite';

import { useStore } from 'models/stores';
import Field from './Field';
import Upload from './Upload';

export default observer(({ form, required = false, field = '' }) => {
  const {
    uiStore: { t },
  } = useStore();
  const file = form[field];
  const error = form.errors.get(field) ? t(form.errors.get(field).error) : '';

  const changeFile = (file) => {
    form.set(field, file);
  };

  return (
    <Field required={required} label={t(`apply_${field}_label`)} center>
      <Upload file={file} error={error} disabled={form.disabled} onChange={changeFile} />
    </Field>
  );
});
